import React from 'react';
import _get from 'lodash/get';
import { PodcastSmallCard } from './mobile/PodcastSmallCard';
import { getResourceType } from '../utils';

export const SeriesSmallCard = ({
  item,
  completed,
  active,
  onClick,
  index,
  resourceItemPageSiteCopy,
  handleCompleteChange,
  isSeriesComplete,
  Component,
  ...rest
}) => {
  const type = getResourceType(item);

  const defaultProps = {
    item,
    type,
    completed,
    active,
    onClick,
    index,
    resourceItemPageSiteCopy,
    handleCompleteChange,
    minutes: _get(item, 'fields.minutes') || _get(item, 'fields.time'),
    isSeriesComplete,
    ...rest,
  };

  if (type === 'podcast') {
    return <PodcastSmallCard {...defaultProps} Component={Component} />;
  }

  return <Component {...defaultProps} />;
};
